<template>
  <div class="link_gift_desBox">
        <header>{{ $t('game_diamond.title0_title') }}</header>
        <p>{{ $t('game_diamond.title0.txt1') }}</p>
        <p>{{ $t('game_diamond.title0.txt2') }}</p>
        <header>{{ $t('game_diamond.title1_title') }}</header>
        <p>{{ $t('game_diamond.title1.txt1') }}</p>
        <p>{{ $t('game_diamond.title1.txt2') }}</p>
        <p>{{ $t('game_diamond.title1.txt3') }}</p>
        <p>{{ $t('game_diamond.title1.txt4') }}</p>
        <header>{{ $t('game_diamond.title2_title') }}</header>
        <p>{{ $t('game_diamond.title2.txt1') }}</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "game_coin_des",
    data() {
      return {
        client:'',
        langType:''
      };
    },
    created() {
        this.langType = this.$route.query.langType;
        this.language()
        this.judgeClient()
    },
    mounted() {
    },
    methods: { 
        // 判断平台
        judgeClient() {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
            this.client = 'iOS';
        } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
            this.client = 'Android';
        } else {
            this.client = 'PC';
        }
        return this.client;
        },
        language() {
            let langs = this.langType.substring(0, 2);
            let lang = this.langType;
            if (langs == "zh") {
                if (lang == "zh_TW" || lang == "zh_HK") {
                this.$i18n.locale = "tc";
                } else {
                this.$i18n.locale = "zh";
                }
            } else if (langs == "en") {
                this.$i18n.locale = "en";
            } else if (langs == "ar") {
                this.$i18n.locale = "ar";
            }else if (langs == "tr") {
                this.$i18n.locale = "tr";
            } else if (langs == "es") {
                this.$i18n.locale = "es";
            } else if (langs == "pt") {
                this.$i18n.locale = "pt";
            } else if (langs == "fr") {
              this.$i18n.locale = "fr"
            } else if (langs == "id") {
              this.$i18n.locale = "id";
            }  else {
                this.$i18n.locale = "en";
            }
            document.title = this.$t('game_diamond.title')
             document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        },
    },
  };
  </script>
  
  <style scoped>
html[lang="ar"] .link_gift_desBox {
  direction: rtl;
}
  * {
    margin: 0;
    padding: 0;
  }
  .link_gift_desBox{
    font-family: 'Montserrat';
    padding: 40px;
    width: 100%;
    height: 100vh;
    /* background: url('../../assets/link_gift_des/bg.png') no-repeat; */
    /* background-size: 100% 100%; */
    box-sizing: border-box;
    color: #262427;
    position: relative;
    background-color: #F5F6F8;
  }
  .link_gift_desBox header{
    font-size: 34px;
    font-weight: 600;
    margin-bottom: 24px;
    /* text-align: center; */
  }
  .link_gift_desBox p{
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 28px;
  }
  .closeBtn{
    position: absolute;
    top: 32px;
    right: 40px;
    width: 22px;
    height: 19px;
    background: url('../../assets/link_gift_des/close.png') no-repeat;
    background-size: 100% 100%;
  }
  
  </style>
  